import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon, BookIcon, PenToolIcon, CalendarIcon, ShieldAlertIcon } from 'lucide-react';
import { ButtonCTA } from './ButtonCTA';
export function OfferStack() {
  const items = [{
    icon: <BookIcon className="w-8 h-8 text-gold" data-id="element-186" />,
    title: 'eBook El Código de Habacuc',
    desc: 'El manual completo paso a paso en formato PDF para entender y aplicar el sistema.'
  }, {
    icon: <PenToolIcon className="w-8 h-8 text-gold" data-id="element-187" />,
    title: 'La Matriz de la Visión',
    desc: 'Plantilla exacta para redactar tu "Tabla de Provisión" sin errores.'
  }, {
    icon: <CalendarIcon className="w-8 h-8 text-gold" data-id="element-188" />,
    title: 'Protocolo de Decretos de 52 Días',
    desc: 'El script diario para reprogramar tu lengua hacia la abundancia.'
  }, {
    icon: <ShieldAlertIcon className="w-8 h-8 text-gold" data-id="element-189" />,
    title: 'Guía de Auditoría de Palabras',
    desc: 'Identifica y elimina las frases que están saboteando tu economía.'
  }];
  return <section className="py-24 bg-white border-y border-parchment-dark" data-id="element-190">
      <div className="container mx-auto px-4" data-id="element-191">
        <div className="max-w-5xl mx-auto" data-id="element-192">
          <FadeIn data-id="element-193">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-ink mb-16" data-id="element-194">
              Lo que obtienes hoy
            </h2>
          </FadeIn>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-195">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-196">
                <div className="flex gap-6 p-6 rounded-xl bg-parchment/30 border border-parchment-dark hover:bg-parchment/60 transition-colors h-full" data-id="element-197">
                  <div className="shrink-0 mt-1 bg-white p-3 rounded-full shadow-sm border border-parchment-dark" data-id="element-198">
                    {item.icon}
                  </div>
                  <div data-id="element-199">
                    <h3 className="text-xl font-bold text-navy mb-2 font-serif" data-id="element-200">
                      {item.title}
                    </h3>
                    <p className="text-charcoal leading-relaxed" data-id="element-201">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.4} className="flex justify-center" data-id="element-202">
            <ButtonCTA onClick={() => document.getElementById('offer')?.scrollIntoView()} data-id="element-203" />
          </FadeIn>
        </div>
      </div>
    </section>;
}